<mat-card appearance="raised">
  <mat-card-header class="card-header">
    <mat-card-title class="card-header__title-container">
      <mat-icon class="mat-icon-xl">business</mat-icon>
      <h2 class="card-header__heading">{{data.name}}</h2>
    </mat-card-title>
    <button *ngIf="editable"
            mat-mini-fab
            class="edit-button"
            color="primary"
            routerLink="edit"
            aria-label="Edit">
      <mat-icon>edit</mat-icon>
    </button>
  </mat-card-header>
  <mat-card-content class="no-bottom-padding">
    <mat-list>
      <mat-list-item>
        <mat-icon matListItemIcon>work</mat-icon>
        <span matListItemTitle>{{data?.dba || '-'}}</span>
        <span matListItemLine>DBA</span>
      </mat-list-item>
      <mat-list-item>
        <mat-icon matListItemIcon>location_on</mat-icon>
        <span matListItemTitle>{{data?.address?.line1}}</span>
        <span matListItemLine>{{data?.address?.city}},
          {{data?.address?.state}}
          {{data?.address?.zip}}
        </span>
        <span *ngIf="data?.address?.line2"
              matListItemLine>{{data?.address?.line2}}
        </span>
      </mat-list-item>
      <mat-list-item>
        <mat-icon matListItemIcon>receipt</mat-icon>
        <span matListItemTitle>{{data?.ein}}</span>
        <span matListItemLine>Tax ID</span>
      </mat-list-item>
      <mat-list-item>
        <mat-icon matListItemIcon>fingerprint</mat-icon>
        <span matListItemTitle>{{data?.organizationId || '-'}}</span>
        <span matListItemLine>Organization ID</span>
      </mat-list-item>
      <mat-list-item>
        <mat-icon matListItemIcon>phone</mat-icon>
        <span matListItemTitle>{{data?.phone || '-'}}</span>
        <span matListItemLine>Primary phone</span>
      </mat-list-item>
      <mat-list-item>
        <mat-icon matListItemIcon>desktop_windows</mat-icon>
        <span matListItemTitle>{{data?.webSite || '-'}}</span>
        <span matListItemLine>Website</span>
      </mat-list-item>
      <mat-list-item>
        <mat-icon matListItemIcon>email</mat-icon>
        <span matListItemTitle>{{(data.emails && data.emails[0]?.email) ? data.emails[0].email : '-'}}</span>
        <span matListItemLine>Email</span>
      </mat-list-item>
    </mat-list>
  </mat-card-content>
</mat-card>
